<template>
  <div
    class="kpis-fornecedor"
    :class="{ 'kpis-fornecedor--dark': darkEnabled }"
  >
    <v-alert
      v-if="!kpis || !kpis.length"
      type="info"
      border="left"
      colored-border
      class="pb-4"
      elevation="0"
    >
      As estatísticas da sua loja não foram processadas ainda. Volte daqui a
      algumas horas.
    </v-alert>

    <section v-if="kpisSimple.length" class="kpis-section">
      <v-row>
        <v-col
          cols="12"
          md="6"
          lg="4"
          v-for="(k, i) in kpisSimple"
          :key="'s-' + i"
        >
          <Card
            class="kpi-card kpi-card--simple elevation-0"
            :ref="k.idkpifornecedor"
          >
            <div class="kpi-card__body">
              <h3 class="kpi-card__nome">{{ k.nome }}</h3>
              <div v-if="k.metadados" class="kpi-chart-container">
                <div
                  class="kpi-chart-number"
                  v-if="k.metadados.tipoExibicao === 'number'"
                >
                  <span
                    v-if="k.metadados.formatador === '$'"
                    class="kpi-chart-number-value"
                  >
                    {{ k.valor | formatMoney() }}
                  </span>
                  <span
                    v-else-if="k.metadados.formatador === 'hs'"
                    class="kpi-chart-number-value"
                  >
                    {{ k.valor | formatPrecision(0) }} horas
                  </span>
                  <span v-else class="kpi-chart-number-value">
                    {{ k.valor | formatPrecision(0) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="kpi-footer">
              <div
                class="kpi-tags"
                v-if="
                  k.metadados && k.metadados.tags && k.metadados.tags.length
                "
              >
                <Chip
                  v-for="t in (k.metadados.tags || []).filter(Boolean)"
                  :key="t"
                  color="green"
                  :text="t"
                  :small="true"
                />
              </div>
              <div class="kpi-timeline">
                <span class="last"
                  >Atualizado
                  {{ k.datacriacao | formatDateTime(getTimeZone) }}</span
                >
                <span class="next"
                  >Próx.
                  {{ k.dataatualizacao | formatDateTime(getTimeZone) }}</span
                >
              </div>
            </div>
          </Card>
        </v-col>
      </v-row>
    </section>

    <section v-if="filteredData.length" class="kpis-section">
      <div class="grid-kpi-multi grid-kpi-multi--bar">
        <Card
          v-for="(k, i) in filteredData"
          :key="'bar-' + i"
          class="kpi-card kpi-card--multi elevation-0"
          :ref="k.idkpifornecedor"
        >
          <div class="kpi-header">
            <FormSelect
              v-if="
                k.valor_multiplo &&
                  k.valor_multiplo.dados &&
                  k.metadados &&
                  !k.metadados.esconderSelecao
              "
              label="Tipo"
              class="kpi-header__select"
              v-model="k.metadados.tipoExibicao"
              :options="kpiTypesMulti"
            />
            <h3 class="kpi-card__nome">{{ k.nome }}</h3>
          </div>
          <div class="kpi-chart">
            <div
              class="kpi-chart-container-info"
              v-if="k.valor_multiplo && k.valor_multiplo.dados"
            >
              <div
                class="kpi-chart-list"
                v-if="k.metadados && k.metadados.tipoExibicao === 'list'"
              >
                <v-simple-table :dark="darkEnabled">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          {{ k.valor_multiplo.campoLabel }}
                        </th>
                        <th class="text-center">
                          {{ k.valor_multiplo.valorLabel }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(val, y) in k.valor_multiplo.dados" :key="y">
                        <td class="text-left">
                          <span v-if="k.metadados.formatadorCampo === 'date'">{{
                            val.campo | formatDate()
                          }}</span>
                          <span v-else>{{ val.campo }}</span>
                        </td>
                        <td class="text-center">
                          <span v-if="k.metadados.formatador === '$'">{{
                            val.valor | formatMoney()
                          }}</span>
                          <span v-else>{{
                            val.valor | formatPrecision(0)
                          }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
              <div v-else class="kpi-chart-apex">
                <apexchart
                  width="100%"
                  height="220"
                  :type="(k.metadados && k.metadados.tipoExibicao) || 'line'"
                  :options="getChartOptions(k)"
                  :series="getChartSeries(k)"
                />
              </div>
            </div>
          </div>
          <div class="kpi-footer">
            <div
              class="kpi-tags"
              v-if="k.metadados && k.metadados.tags && k.metadados.tags.length"
            >
              <Chip
                v-for="t in (k.metadados.tags || []).filter(Boolean)"
                :key="t"
                color="green"
                :text="t"
                :small="true"
              />
            </div>
            <div class="kpi-timeline">
              <span class="last"
                >Atualizado
                {{ k.datacriacao | formatDateTime(getTimeZone) }}</span
              >
              <span class="next"
                >Próx.
                {{ k.dataatualizacao | formatDateTime(getTimeZone) }}</span
              >
            </div>
          </div>
        </Card>
      </div>
    </section>
  </div>
</template>

<script>
import FormSelect from "@/components/form/FormSelect";
import VueApexCharts from "vue-apexcharts";
import Card from "@/components/Card";
import Chip from "@/components/Chip";
import { mapGetters } from "vuex";
import * as moment from "moment";
import * as _ from "lodash";

export default {
  props: {
    kpis: Array,
    filter: Object
  },
  name: "KpisFornecedor",
  components: {
    apexchart: VueApexCharts,
    FormSelect,
    Card,
    Chip
  },
  data: () => ({
    filteredData: []
  }),
  watch: {
    "filter.search"(newVal, oldVal) {
      if (newVal != oldVal && newVal) {
        this.$emit("change-search", false);
        this.filteredData = this.getFilteredData(this.kpisMultiple);
      }
    }
  },
  computed: {
    ...mapGetters(["getTimeZone", "darkEnabled"]),
    kpiTypesMulti() {
      return [
        {
          text: "Lista",
          value: "list",
          icon: "fas fa-list"
        },
        {
          text: "Gráfico de linha",
          value: "line",
          icon: "fas fa-chart-line"
        },
        {
          text: "Gráfico de barras",
          value: "bar",
          icon: "fas fa-chart-bar"
        },
        {
          text: "Gráfico de pizza",
          value: "pie",
          icon: "fas fa-chart-pie"
        },
        {
          text: "Gráfico de donut",
          value: "donut",
          icon: "far fa-circle"
        }
      ];
    },
    kpisSimple() {
      return (this.kpis || []).filter(k => k.tipo === "SIMPLES");
    },
    kpisMultiple() {
      return (this.kpis || []).filter(k => k.tipo === "MULTIPLO");
    }
  },
  mounted() {
    this.filteredData = this.getFilteredData(this.kpisMultiple);
  },
  methods: {
    getFilteredData(data) {
      return data.map(k => {
        const {
          metadados: { canFilter },
          valor_multiplo
        } = k;
        const data = _.get(valor_multiplo, "dados", []);

        const _d = canFilter
          ? data.filter(d => {
              const isG = d.campo >= this.filter.initDate;
              const isL = d.campo <= this.filter.finalDate;
              const isTrue = isG && isL;
              return isTrue;
            })
          : data;
        const val = { ...k.valor_multiplo, dados: _d };
        return { ...k, valor_multiplo: val };
      });
    },
    getChartOptions(k) {
      const formatadorCampo = _.get(k, "metadados.formatadorCampo") || "";
      const categories = _.get(k, "valor_multiplo.dados", []).map(d =>
        formatadorCampo === "date"
          ? moment(d.campo).format("DD/MM/YYYY")
          : d.campo
      );
      const type = _.get(k, "metadados.tipoExibicao") || "line";
      const chartColors = ["#00558e", "#50b748", "#0077a3", "#6bc96f"];
      const labelColor = this.darkEnabled ? "#b0bec5" : undefined;
      if (type === "pie" || type === "donut") {
        return {
          labels: categories,
          colors: chartColors,
          ...(this.darkEnabled
            ? {
                theme: { mode: "dark" },
                chart: { background: "transparent" },
                legend: { labels: { colors: "#e0e0e0" } }
              }
            : {})
        };
      }
      return {
        theme: {
          mode: this.darkEnabled ? "dark" : "light"
        },
        chart: {
          height: 200,
          type,
          stacked: false,
          ...(this.darkEnabled
            ? { foreColor: "#eceff1", background: "transparent" }
            : {})
        },
        colors: chartColors,
        dataLabels: {},
        grid: this.darkEnabled
          ? { borderColor: "rgba(255, 255, 255, 0.08)" }
          : {},
        xaxis: {
          categories,
          ...(labelColor ? { labels: { style: { colors: labelColor } } } : {})
        },
        yaxis: [
          {
            axisTicks: { show: false },
            axisBorder: { show: true },
            title: {
              text: k.valor_multiplo.valorLabel,
              ...(labelColor ? { style: { color: labelColor } } : {})
            },
            labels: labelColor ? { style: { colors: labelColor } } : {}
          }
        ],
        ...(this.darkEnabled
          ? {
              legend: {
                labels: { colors: "#e0e0e0" }
              }
            }
          : {}),
        tooltip: {
          shared: false,
          intersect: false,
          x: { show: true },
          theme: this.darkEnabled ? "dark" : "light"
        }
      };
    },
    getChartSeries(k) {
      const type = _.get(k, "metadados.tipoExibicao") || "line";
      const dados = _.get(k, "valor_multiplo.dados" || []);
      const name = _.get(k, "valor_multiplo.valorLabel" || "");
      if (type === "pie" || type === "donut") {
        const total = dados
          .map(d => d.valor)
          .reduce((a, b) => Number(a) + Number(b), 0);
        return dados.map(d => (d.valor / total) * 100);
      }
      return [
        {
          name,
          data: (dados || []).map(d => d.valor)
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.kpis-fornecedor {
  width: 100%;
  --kpi-accent: #00558e;
  --kpi-border: #e0e0e0;
  --kpi-title: #333;
  --kpi-value: #00558e;
  --kpi-muted: #666;
  --kpi-footer-border: #eee;
  --kpi-hover-shadow: rgba(0, 0, 0, 0.08);

  &.kpis-fornecedor--dark {
    --kpi-accent: #90caf9;
    --kpi-border: rgba(255, 255, 255, 0.12);
    --kpi-title: rgba(255, 255, 255, 0.87);
    --kpi-value: #90caf9;
    --kpi-muted: rgba(255, 255, 255, 0.6);
    --kpi-footer-border: rgba(255, 255, 255, 0.1);
    --kpi-hover-shadow: rgba(0, 0, 0, 0.35);
  }
}

.kpis-section {
  padding-bottom: 2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  background: var(--dash-card-bg);
}

.kpis-section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--kpi-accent);
  padding-bottom: 1rem;
}

/* Grid barra/coluna e outros: máx. 2 por linha (min 50%) */
.grid-kpi-multi--bar,
.grid-kpi-multi--other {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.25rem;
  background: var(--dash-card-bg);
}

@media (max-width: 960px) {
  .grid-kpi-multi--bar,
  .grid-kpi-multi--other {
    grid-template-columns: 1fr;
  }
}

/* Cards: elevation-0 + borda leve */
.kpi-card {
  border: 1px solid var(--kpi-border) !important;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  min-width: 0;
  transition: box-shadow 0.2s ease;
}

.kpi-card:hover {
  box-shadow: 0 2px 8px var(--kpi-hover-shadow);
}

.kpi-card--simple {
  min-height: 160px;
}

.kpi-card--multi {
  min-height: 340px;
}

.kpi-card__body {
  padding-bottom: 0.5rem;
  flex: 1;
}

.kpi-card__nome {
  font-size: 1rem;
  font-weight: 600;
  color: var(--kpi-title);
  padding: 0 0 0.75rem 0;
  line-height: 1.3;
}

.kpi-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.75rem;
}

.kpi-header__select {
  max-width: 120px;
}

.kpi-chart {
  flex: 1;
  min-height: 200px;
  display: flex;
  flex-direction: column;
}

.kpi-chart-container-info {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.kpi-chart-list {
  overflow-y: auto;
  max-height: 300px;
}

.kpi-chart-apex {
  width: 100%;
  min-height: 200px;
}

.kpi-chart-container {
  width: 100%;
}

.kpi-chart-number {
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.kpi-chart-number-value {
  font-size: 1.75rem;
  font-weight: 600;
  color: #00558e;
}

.kpi-footer {
  padding-top: 0.75rem;
  padding-top: auto;
  border-top: 1px solid #eee;
  width: 100%;
}

.kpi-tags {
  font-size: 0.85rem;
  text-align: right;
  padding-bottom: 0.25rem;
}

.kpi-timeline {
  font-size: 0.75rem;
  color: var(--kpi-muted);
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.kpi-timeline .last,
.kpi-timeline .next {
  color: var(--kpi-muted);
}
</style>

<style lang="scss">
.apexcharts-canvas {
  width: 100% !important;
  min-height: 200px !important;
}

.kpi-card .content-card {
  padding: 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
</style>
